import { render, staticRenderFns } from "./appr-cement.vue?vue&type=template&id=67232fa9&scoped=true"
import script from "./appr-cement.vue?vue&type=script&lang=js"
export * from "./appr-cement.vue?vue&type=script&lang=js"
import style0 from "./appr-cement.vue?vue&type=style&index=0&id=67232fa9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67232fa9",
  null
  
)

export default component.exports